let config = {
    app_url: "",
    openkit_url: "",
    subdomain: "",
    token: "",
};
function init() {
    if (process.env.NODE_ENV === "production" &&
        window.location.hostname == "localhost") {
        // Docker
        config.app_url = "http://localhost:8090/api/";
        config.openkit_url = process.env.VUE_APP_OPENKITURL;
        config.subdomain =
            process.env.NODE_ENV === "production"
                ? window.location.host.split(".")[0]
                : process.env.VUE_APP_SUBDOMAIN;
    }
    else {
        // Normal
        config.app_url =
            process.env.NODE_ENV === "production"
                ? window.location.protocol + "//" + window.location.hostname + "/api/"
                : process.env.VUE_APP_APIURL;
        config.openkit_url = process.env.VUE_APP_OPENKITURL;
        config.subdomain =
            process.env.NODE_ENV === "production"
                ? window.location.host.split(".")[0]
                : process.env.VUE_APP_SUBDOMAIN;
    }
}
init();
export default config;
